import React from 'react';

import { TagDropdownItem } from '../../../../components/tag-dropdown/tag-dropdown-item';
import { ManageTags } from '../../../../components/tag-dropdown/manage-tags';
import { useFulfillmentPlanTagsContext } from './tag-context';

import style from './tags.module.less';

export const BulkFulfillmentPlanTagDropdownBody = () => {
  const { manageTagsAction, onTagToggled, sellerTags, addTagIds } = useFulfillmentPlanTagsContext();

  return (
    <>
      <ManageTags className={style['fulfillment-plan-tag-dropdown-header']} manageTagsAction={manageTagsAction} />
      <div className={style['fulfillment-plan-tag-dropdown-body']}>
        {sellerTags.map((tag, index) => (
          <TagDropdownItem
            key={index}
            className={style['fulfillment-plan-tag-dropdown-item']}
            isChecked={addTagIds.indexOf(tag.tagId) !== -1}
            onTagToggled={() => onTagToggled(tag.tagId)}
            tag={tag}
          />
        ))}
      </div>
    </>
  );
};
